import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7afa02ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "paddleComponent" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-info" }, " Please wait, we will redirect you back to home page in 7 seconds. ", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_7 = {
  key: 1,
  class: "text-info"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "text-info"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  "data-bs-target": "#cancelSubscriptionModal",
  "data-bs-toggle": "modal",
  class: "cursor-pointer text-danger"
}, "cancel ", -1))
const _hoisted_11 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_12 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_13 = {
  class: "nav-link strong active",
  id: "plan-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#plan-tab-pane",
  type: "button",
  ref: "planBtn",
  role: "tab"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "nav-item strong",
  role: "presentation"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "nav-link strong",
    id: "address-tab",
    "data-bs-toggle": "tab",
    "data-bs-target": "#address-tab-pane",
    type: "button",
    role: "tab"
  }, "Billing Address")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "nav-item",
  role: "presentation"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "nav-link strong",
    id: "contact-tab",
    "data-bs-toggle": "tab",
    "data-bs-target": "#invoices-tab-pane",
    type: "button",
    role: "tab"
  }, "Invoices")
], -1))
const _hoisted_16 = {
  class: "tab-content p-1 pt-3",
  id: "myTabContent"
}
const _hoisted_17 = {
  class: "tab-pane fade show active",
  id: "plan-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_18 = { class: "row mt-4" }
const _hoisted_19 = { class: "card-body plan mb-5" }
const _hoisted_20 = { class: "card-title" }
const _hoisted_21 = { class: "card-title" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "card-title" }, "/month", -1))
const _hoisted_23 = { class: "card-text" }
const _hoisted_24 = { class: "p-0 ps-4 mt-3 plan-feature-set" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "card-footer bg-transparent border-0 p-3 position-absolute bottom-0 w-100" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 2,
  class: "btn btn-outline-secondary disabled float-end",
  disabled: ""
}
const _hoisted_32 = {
  key: 3,
  "data-bs-target": "#cancelSubscriptionModal",
  "data-bs-toggle": "modal",
  class: "btn btn-danger float-end"
}
const _hoisted_33 = {
  class: "tab-pane fade show",
  id: "address-tab-pane",
  role: "tabpanel",
  tabindex: "1"
}
const _hoisted_34 = {
  class: "tab-pane fade show",
  id: "invoices-tab-pane",
  role: "tabpanel",
  tabindex: "2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BusinessInformation = _resolveComponent("BusinessInformation")!
  const _component_TransactionsView = _resolveComponent("TransactionsView")!
  const _component_CheckAddressModal = _resolveComponent("CheckAddressModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loadingForSubscription)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (!_ctx.loadingForSubscription)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.isCanceledAt)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Your subscription will be canceled on " + _toDisplayString(_ctx.isCanceledAt) + ". ", 1))
            : _createCommentVNode("", true),
          (_ctx.trailUntil)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                _createTextVNode(" Your trail period ends on " + _toDisplayString(_ctx.trailUntil) + ".", 1),
                _hoisted_8,
                (!_ctx.isCanceledAt)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                      _createTextVNode(" You can cancel your subscription before the trail period ends: "),
                      _hoisted_10
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("ul", _hoisted_11, [
              _createElementVNode("li", _hoisted_12, [
                _createElementVNode("button", _hoisted_13, "Your Plan", 512)
              ]),
              _hoisted_14,
              _hoisted_15
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plans, (plan) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-sm-3 mb-3 d-flex flex-column",
                      key: plan.id
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["card flex-grow-1", { 'active': _ctx.getPaddlePlanNames.length ? _ctx.getPaddlePlanNames?.map((p) => p.name)?.includes(plan.name) : plan.name == 'Free' }])
                      }, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("h5", _hoisted_20, _toDisplayString(plan.name), 1),
                          _createElementVNode("h6", _hoisted_21, [
                            _createTextVNode("$" + _toDisplayString(plan.price), 1),
                            _hoisted_22
                          ]),
                          _createElementVNode("p", _hoisted_23, [
                            _createElementVNode("ul", _hoisted_24, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.features, (feature) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  class: "p-0",
                                  key: feature,
                                  innerHTML: feature
                                }, null, 8, _hoisted_25))
                              }), 128)),
                              (plan.additional)
                                ? (_openBlock(), _createElementBlock("hr", _hoisted_26))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.additional, (feature) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  class: "p-0",
                                  key: feature,
                                  innerHTML: feature
                                }, null, 8, _hoisted_27))
                              }), 128))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          (!_ctx.isPaidAccount && !_ctx.getPaddlePlanNames?.map((p) => p.name)?.includes(plan.name) && plan.priceId)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                "data-bs-target": "#checkAddressModal",
                                "data-bs-toggle": "modal",
                                onClick: ($event: any) => {_ctx.selectedPriceId = plan.priceId;},
                                class: "btn btn-primary float-end"
                              }, " Subscribe ", 8, _hoisted_29))
                            : _createCommentVNode("", true),
                          (_ctx.isPaidAccount && !_ctx.getPaddlePlanNames?.map((p) => p.name)?.includes(plan.name) && plan.priceId)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                onClick: ($event: any) => (_ctx.upgrade(plan.id)),
                                "data-bs-target": "#upgradeModal",
                                "data-bs-toggle": "modal",
                                class: "btn btn-primary float-end"
                              }, "Upgrade", 8, _hoisted_30))
                            : _createCommentVNode("", true),
                          (_ctx.isCanceledAt && !plan.priceId)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, "Will be selected "))
                            : _createCommentVNode("", true),
                          (_ctx.getPaddlePlanNames?.map((p) => p.name)?.includes(plan.name) && !_ctx.isCanceledAt)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, "Cancel "))
                            : _createCommentVNode("", true)
                        ])
                      ], 2)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_BusinessInformation)
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_TransactionsView)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_CheckAddressModal, { onNext: _ctx.openCheckout }, null, 8, ["onNext"])
  ]))
}